import { CheckIcon } from '@change/ds-icons';

import { Badge } from '@change/ds-core-ui/next';

export const ResponseBadge: React.FC<{ response: string | undefined }> = ({ response }) => {
	return response ? (
		<Badge
			label="Responded"
			variant="neutral"
			className="bg-fill-success-weaker border-stroke-success-weak text-typography-success mb-2 w-fit border-[1px] font-normal"
			leadingIcon={<CheckIcon />}
		/>
	) : (
		<Badge
			label="Awaiting Response"
			variant="neutral"
			iconOnly={false}
			className="bg-fill-inverse-strong border-stroke-weaker w-fit border-[1px]"
		/>
	);
};
